<script>

  import { createEventDispatcher, onMount } from 'svelte'
  import dayjs from 'dayjs'
  import 'dayjs/locale/fr'

  // props
  export let customclass
  export let availableDates = null
  export let dateFormat;
  export let title
  export let locale
  export let showAllFutureDates;
  export let calendarLocation;
  export let datepicked;


  // data
  const dispatch = createEventDispatcher()
  let elModal // HTMLElement
  let inputTxt // string, d�fault date = now
  let isOpenCalendar = false // true: show calendar
  let arrDays = "Su_Mo_Tu_We_Th_Fr_Sa".split("_")
  let arrDays2 = arrDays
  const currentDay = +dayjs().format('D') // 1..31
  const currentMonth = +dayjs().format('M') // 1..12
  const currentYear = +dayjs().format('YYYY') // 2021...
  let selectedMonth = +dayjs().format('M') // 1..12
  let selectedYear = +dayjs().format('YYYY') // 2021...
  let rows = initRows()

  
  $: dispatch('datepicked', {
    datepicked: inputTxt
  })
 

  async function importLocale(loc) {
    // const localeModule = await import(`./dayjs/locale/${locale}.js`);
    // https://cdn.jsdelivr.net/npm/dayjs@1/locale/zh-cn.js
    const localeModule = await import(`https://cdn.jsdelivr.net/npm/dayjs@1/locale/${loc}.js`);
    dayjs.locale(localeModule.default);
  }

  // life cycle
  onMount(async () => {
    window.dayjs = dayjs;
    if (null !== locale &&  locale != undefined) {
      await importLocale(locale);
      if (window[`dayjs_locale_${locale}`] !== undefined && window[`dayjs_locale_${locale}`].weekdaysMin !== undefined) {
        dayjs.locale(locale) // use locale
        //inputTxt = dayjs().format(dateFormat) // current day month year in input
        arrDays = ucAll(window[`dayjs_locale_${locale}`].weekdaysMin)
        arrDays2 = [...arrDays]
        if (window[`dayjs_locale_${locale}`].weekStart == 1)  {
          const firstElement = arrDays2.shift();
          arrDays2.push(firstElement);
        }
      } else {
        dayjs.locale("en") 
      }

    }
    

    affecteRows()
  })

  // functions
  /**
   * Click outside of the modal will close it
   * @param e
   */
  function handleClickModal(e) {
    if (e.target === elModal) {
      isOpenCalendar = false
    }
  }

  function initRows() {
    return [
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0]
    ]
  }

  function affecteRows() {
    rows = initRows()
        
    const firstDayOfCurrentMonth = ucFirst(
      dayjs(selectedYear + '-' + selectedMonth)
        .startOf('month')
        .format('dd')
    ) // 'Lu'
    const lastDayOfCurrentMonth = +dayjs(selectedYear + '-' + selectedMonth)
      .endOf('month')
      .format('D') // 31
    let iRow = 0
    let iCol = 0
    let start = false
    let cpt = 0
    for (iRow = 0; iRow < 6; iRow++) {
      arrDays2.forEach((daystr) => {
        if (cpt > lastDayOfCurrentMonth) {
          return
        }
        if (!start && daystr === firstDayOfCurrentMonth) {
          cpt++
          start = true
        }
        rows[iRow][iCol] = cpt
        iCol++
        if (start) {
          cpt++
          
        }
      })
      iCol = 0
    }
  }

  function ucAll(arr) {
    for (let i = 0; i < arr.length; i++) {
      arr[i] = ucFirst(arr[i])
    }
    return arr;
  }
  function ucFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  function previousMonth() {
    selectedMonth--
    if (selectedMonth <= 0) {
      selectedMonth = 12
      selectedYear--
    }
    affecteRows()
  }

  function nextMonth() {
    selectedMonth++
    if (selectedMonth > 12) {
      selectedMonth = 1
      selectedYear++
    }
    affecteRows()
  }
  
  function dateAvailable(y, m, d) {
    if (availableDates != null && showAllFutureDates !== true) {
      return availableDates.call(this,  dayjs(y + '-' + m + '-' + d).format('YYYY-MM-DD'))
    }else if(showAllFutureDates == true){
      return dayjs(y + '-' + m + '-' + d).format('YYYY-MM-DD');
    }else {
      return false
    }
    
  }

  function selectDate(y, m, d) {
    inputTxt = dayjs(y + '-' + m + '-' + d).format('YYYY-MM-DD');
    dispatch('datepicked', { datepicked: inputTxt });
    isOpenCalendar = false;
    
  }
  function hideCalendar(event) {
    const dateSelect = document.getElementById('dateSelect');
    if (dateSelect && !dateSelect.contains(event.target)) {
      isOpenCalendar = false;
    }
    
  }
  document.body.addEventListener('click', hideCalendar);
  




</script>

{#if isOpenCalendar}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="relative z-10 calendar-wrapper"
    bind:this={elModal}
    on:click={handleClickModal}
  >
    
      <div class="{calendarLocation === "course_search" ? "w-[300px] right-0  md:right-1/2 md:translate-x-1/2 " : "max-w-sm w-full"}  shadow-[10px] mx-auto absolute top-10 ">
        <div class="{calendarLocation === "course_search" ? "p-0" : "md:p-8 p-5"} dark:bg-gray-800 bg-white rounded-md">
         
          <div class="flex items-center justify-between  rounded-lg overflow-x-auto {calendarLocation === "course_search" ? "p-0" : "pt-12"}" style="border:1px solid #ddd;">
            <table class="w-full border-0  overflow-hidden shadow-card">
              <thead>
                <tr class="border-none bg-snd-lightgrey h-12" style="background-color:#ddd;">
                  <th class="border-none !px-1 !py-1 "><button on:click={previousMonth} aria-label="calendar backward" class="text-pm-pink justify-self-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-chevron-left"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <polyline points="15 6 9 12 15 18" />
                    </svg>
                  </button></th>
                  <th class="border-none text-center !px-1 !py-1 " colspan="5"><span class="focus:outline-none text-base font-bold text-pm-black"
                    >{ucFirst(dayjs(selectedYear + '-' + selectedMonth).format('MMMM YYYY'))}</span
                  ></th>
                  <th class="border-none text-right !px-1 !py-1 "><button on:click={nextMonth} aria-label="calendar forward" class="ml-3 text-pm-pink">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler  icon-tabler-chevron-right"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <polyline points="9 6 15 12 9 18" />
                    </svg>
                  </button></th>
                </tr>
                <tr class="bg-pm-white">
                  {#each arrDays2 as day}
                    <th class="border-none p-1">
                      <div class="w-full flex justify-center">
                        <p class="text-base !px-1 !py-1 font-bold text-center text-pm-grey mb-0">
                          {day}
                        </p>
                      </div>
                    </th>
                  {/each}
                </tr>
              </thead>
              <tbody class="bg-pm-white">
                {#each rows as col}
                  <tr class="">
                    {#each col as i}
                      <td class="border-none p-1">
                        <div class="!px-1 !py-1 flex w-full justify-center empty:hidden">
                          {#if i > 0}
                            {#if false === dateAvailable(selectedYear, selectedMonth, i)}
                              <div class="text-pm-grey/20">{i}</div>
                            {:else}
                              {#if i <= currentDay && selectedMonth === currentMonth && selectedYear === currentYear && currentDay}
                                <button
                                  on:click={() => {
                                    selectDate(selectedYear, selectedMonth, i);
                                    
                                  }}
                                  disabled='{!dateAvailable(selectedYear, selectedMonth, i)}'
                                  class="!w-5 !h-5 rounded cursor-not-allowed pointer-events-none  text-base flex items-center justify-center font-medium text-white {i === currentDay ? "rounded-full border border-solid border-pm-black" : "text-pm-grey/50"}"
                                  >{i}</button>
                              {:else}
                                <div class="text-base text-pm-grey/50 available-date">
                                  <button 
                                    class="!w-5 !h-5 border-none available-date {calendarLocation === 'course_search' && (selectedYear > currentYear || (selectedYear === currentYear && selectedMonth >= currentMonth)) ? 'text-pm-black font-medium' : 'cursor-not-allowed pointer-events-none text-pm-grey'}"
                                    on:click={() => selectDate(selectedYear, selectedMonth, i)}
                                    disabled={!dateAvailable(selectedYear, selectedMonth, i)}
                                  >
                                    {i}
                                  </button>
                                </div>
                              {/if}
                            {/if}
                          {/if}
                        </div>
                      </td>
                    {/each}
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        </div>
    
    </div>
  </div>
{/if}

<input
  type="text"
  bind:value={inputTxt}
  class={customclass}
  on:click={() => {
    isOpenCalendar = true
  }}
  title="{title}"
  placeholder="{title}"
  readonly={calendarLocation === "course_search" ? true : false}
/>

<style>
  thead tr {
    /* background-color: #ddd; */
  }
</style>